export enum WalletHistoryTypes {
    DEPOSIT='deposit',
    SOLD='sold',
    BOUGHT='bought',
    SELF='self',
}